import React, { useEffect, useState } from "react";
import { Container } from "@mui/material";
import CardList from "../component/CardList";
import { getProducts } from "../service/productService";

const SummaryCardPage = () => {
  const [products, setProducts] = useState([]);

  const fetchData = async () => {
    const { products } = await getProducts(null, null, "updateDate");

    setProducts(products);
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Container>
      <CardList data={products} />
    </Container>
  );
};

export default SummaryCardPage;
